import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

/**
 * PermissionsSkeleton
 * Shown inside the Edit Role modal while the permission catalogue
 * or the role's own permissions are loading.
 * Matches the real checkbox-grid layout: Select All row + 2-column grid of checkbox pills.
 */
const PermissionsSkeleton: React.FC<{
    /** How many checkbox placeholder rows to show (default: 6) */
    count?: number;
}> = ({ count = 6 }) => (
    <div className="flex flex-col gap-2 animate-fade-in-up">
        {/* "Select All" placeholder row */}
        <div className="flex items-center gap-2 mb-1">
            <ShimmerBox className="w-4 h-4 rounded" delay="0s" />
            <ShimmerBox className="h-3 w-20 rounded" delay="0.05s" />
        </div>

        {/* Checkbox grid placeholders — 2 columns matching the real UI */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-60 overflow-hidden pr-1">
            {Array.from({ length: count }).map((_, i) => (
                <ShimmerBox
                    key={i}
                    className="rounded-lg border h-9"
                    style={{ borderColor: 'var(--v2-border-card)' }}
                    delay={`${i * 0.05}s`}
                />
            ))}
        </div>
    </div>
);

export default PermissionsSkeleton;
